<mat-form-field>
  <label>
    <input
      matInput
      type="text"
      [placeholder]="('search' | i18n) || 'search...' | titlecase"
      [formControl]="searchControl"
      data-cy="text-search-input" />
  </label>
  <button
    mat-button
    matSuffix
    mat-icon-button
    aria-label="Search"
    (click)="search()">
    <mat-icon svgIcon="magnify"></mat-icon>
  </button>
</mat-form-field>
